import FormikTextarea from '@/Component/Common/Forms/FormikTextarea';
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import Modal from '@/Component/Common/Modal';
import { CloseModalSVG, LoaderSVG } from '@/Component/Common/SVGs/CommonSVG';
import { AddDraftAPI } from '@/Utils/APIRequest/Endpoints';
import usePost from '@/Utils/Hooks/usePost';
import { RequiredField, YupObject } from '@/Utils/ValidationSchema';
import ValidationMsg from '@/Utils/ValidationSchema/ValidationMsg';
import { ErrorMessage, Form, Formik } from 'formik';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';

const UploadDraftModal = (props) => {
    const { uploadDraftModalOpen, setUploadDraftModalOpen, setDraftModalOpen, uploadLoader, mainListRefetch, translations } = props;
    const [mediaType, setMediaType] = useState(uploadDraftModalOpen?.mediaType?.includes('image') ? 'image' : 'video');
    const [buttonLoader, setButtonLoader] = useState(false);

    console.log("uploadDraftModalOpen", uploadDraftModalOpen);
    

    const [videoPath, setVideoPath] = useState('');

    // POST API
    const { isPending, mutate } = usePost(`${AddDraftAPI}/${uploadDraftModalOpen?.campaignInfluencerId}`, null, (response) => {
        if (response?.status == 200 || response?.status == 201) {
            mainListRefetch();
            setUploadDraftModalOpen(null);
            uploadDraftModalOpen?.JobDetailDataRefetch();
            uploadDraftModalOpen?.commentRefetch();
            uploadDraftModalOpen?.detailRefetch();
        }
    }, null);

    useEffect(() => {
        if (!uploadDraftModalOpen?.responseData?.filepath?.includes('jpg')) {
            setVideoPath(uploadDraftModalOpen?.responseData?.filepath);
            setTimeout(() => {
                console.log("videoPath", videoPath);
            }, 1000)            
        }
    }, [uploadDraftModalOpen?.responseData?.filepath]);

    // const videoRef = useRef(null);
    // const playerRef = useRef<any>(null);

    // useEffect(() => {
    //     if (videoRef.current && !uploadDraftModalOpen?.responseData?.filepath.includes('jpg')) {
    //         playerRef.current = videojs(videoRef.current, {
    //             controls: true,
    //             autoplay: false,
    //             preload: 'auto',
    //             fluid: false,
    //             controlBar: {
    //                 pictureInPictureToggle: false
    //             },
    //         });

    //         playerRef.current.src({
    //             src: uploadDraftModalOpen?.responseData?.filepath,
    //             type: 'application/x-mpegURL'
    //         });

    //         playerRef.current.ready(() => {
    //             console.log('Player is ready');
    //         });
    //     }

    //     return () => {
    //         if (playerRef.current) {
    //             playerRef.current.dispose();
    //         }
    //     };
    // }, [videoRef, uploadDraftModalOpen?.responseData?.filepath]);

    return (
        <Modal modalSize="xl:w-1/4 w-1/1" modal={uploadDraftModalOpen} setModal={setUploadDraftModalOpen} childMainClass="max-h-[95vh] overflow-y-auto">
            <div onClick={() => setUploadDraftModalOpen(null)} className='absolute -top-2 -right-2 cursor-pointer'>
                <CloseModalSVG customClass="max-w-6 max-h-6" />
            </div>
            <div className='flex flex-col gap-5'>
                <h3 className='text-xl font-bold'>{translations?.uploadDraft}</h3>
                <div className='aspect-square w-full h-full bg-gray'>
                    {mediaType == 'image' ?
                        <Image src={uploadDraftModalOpen?.responseData?.filepath} width={375} height={375} alt="Profile 1" className='w-full h-full object-contain' />
                        :
                        <video controls className='w-full h-full object-contain' poster={uploadDraftModalOpen?.thumbnail}>
                            <source src={uploadDraftModalOpen?.responseData?.filepath} type='video/mp4' />
                            <source src={uploadDraftModalOpen?.responseData?.filepath} type='video/ogg' />
                            <source src={uploadDraftModalOpen?.responseData?.filepath} type='video/webm' />
                            <source src={uploadDraftModalOpen?.responseData?.filepath} type='video/quicktime' />
                            {/* <source src={videoPath} type='video/mov' /> */}
                            {/* <source src={uploadDraftModalOpen?.responseData?.filepath} type='video/x-msvideo' />
                            <source src={uploadDraftModalOpen?.responseData?.filepath} type='video/x-matroska' /> */}
                            {/* <source src={uploadDraftModalOpen?.responseData?.filepath} type='video/mkv' />
                            <source src={uploadDraftModalOpen?.responseData?.filepath} type='video/mov' /> */}
                        </video>
                    }
                </div>
                <Formik
                    enableReinitialize
                    initialValues={{
                        comment: "",
                    }}
                    validationSchema={YupObject({
                        comment: RequiredField(translations?.descriptionValidation),
                    })}
                    onSubmit={(values: any) => {
                        values.draft_id = uploadDraftModalOpen?.currentDraftId ?? null
                        values.draft_name = uploadDraftModalOpen?.responseData?.fileName
                        values.type = mediaType,
                        values.thumbnail = uploadDraftModalOpen?.thumbnail
                        mutate(values);
                    }}
                >
                    {({ values, setFieldValue, errors }) => {
                        return (
                            <Form>
                                <div className="flex flex-col col-span-12">
                                    <FormikTextarea textareaProps={{ type: "text", name: "comment", autoComplete: "new-email", placeholder: "Enter Description...", rows: 4 }} />
                                    <ErrorMessage name="comment" component="div" render={(msg) =>
                                        <ValidationMsg errorMsg={msg} />
                                    } />
                                </div>
                                <div className="flex items-center justify-end gap-3.5 mt-5">
                                    <PrimaryButton buttonType="submit" customClass="w-full flex items-center justify-center gap-1.5" disabled={uploadLoader || isPending} >
                                        {uploadLoader ? translations?.uploading : translations?.uploadDraft}
                                        {isPending && <LoaderSVG />}
                                    </PrimaryButton>
                                </div>
                            </Form>
                        );

                    }}
                </Formik>
            </div>
        </Modal>
    )
}

export default UploadDraftModal
